import axios from 'axios';
import { userActions } from './actions';
import i18n from 'i18next';
import { notify } from './components/CommonNotification/CommonNotification';
import Cookies from 'universal-cookie';
import { removeLocalStorageItem } from './utils/cookieAndLocalStorageUtils';
import { isSessionExpiredUnauthorized } from './utils/unauthorizedRule';
import { recordSessionExpiredRedirect } from './utils/loginLoopGuard';

const cookies = new Cookies();

export default {
  setupInterceptors: (store) => {
    // Helper checks
    const isSalesforceAPI = (url) =>
      url?.toLowerCase().includes('/salesforce/');

    const logoutUser = () => {
      removeLocalStorageItem('access_token');
      cookies.remove('username', { path: '/' });
      cookies.remove('user_session', { path: '/' });
      store.dispatch(userActions.logout());
    };

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const { response } = error;

        if (!response) return Promise.reject(error);

        const { status, config } = response;
        const { url } = config;

        if (status === 401 && isSessionExpiredUnauthorized(url)) {
          notify('error', i18n.t('SESSIONEXPIRED')); // Single message

          if (!isSalesforceAPI(url)) {
            recordSessionExpiredRedirect();
            logoutUser();
          }
        }

        return Promise.reject(error);
      },
    );
  },
};
